import React from "react";
import { BsShieldFillPlus } from "react-icons/bs";
import { RiShieldKeyholeFill } from "react-icons/ri";
import { BsLifePreserver } from "react-icons/bs";
import mainMock from "../../assets/tradeany.jpg";
import cryptosec from "../../assets/cryptosec.jpg";

import { domain } from "../../data";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoFacebook } from "react-icons/io";
import { FaWhatsappSquare } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io5";
import { AiFillTikTok } from "react-icons/ai";
import { FaLine } from "react-icons/fa";
import { SiCoinmarketcap } from "react-icons/si";
import Votingcarousel from "./Votingcarousel";

export default function PowerfulTool() {
	const assetData = [
		{
			title: "Smart Price Alerts",
			desc: "Stay informed with customizable price alerts that help you make timely trading decisions.",
			logo: <BsLifePreserver />,
			id: 1,
		},
		{
			title: "Crypto Trading",
			desc: "Access a wide range of cryptocurrencies with advanced trading tools and real-time market data.",
			logo: <BsShieldFillPlus />,
			id: 1,
		},
		{
			title: "Rapid Order Fulfillment",
			desc: "Experience lightning-fast order execution to capitalize on market opportunities without delay.",
			logo: <RiShieldKeyholeFill />,
			id: 3,
		},
	];

	const cryptoSecData = [
		{
			title: "Secure Wallet Management",
			desc: "Using reputable wallets and hardware storage options ensures your private keys remain protected from hacking and theft. Regularly updating wallet software and enabling multi-factor authentication adds additional layers of security. Proper wallet management is essential to safeguard your digital assets.",
			logo: <BsLifePreserver />,
			id: 1,
		},
		{
			title: "Phishing and Social Engineering Prevention",
			desc: "Cryptocurrency users must be vigilant against phishing scams that mimic legitimate platforms to steal login credentials. Never share sensitive information via unsolicited messages and verify website URLs before entering personal data. Educating oneself about common scams helps prevent unauthorized access and financial loss.",
			logo: <BsShieldFillPlus />,
			id: 1,
		},
		{
			title: "Secure Private Key Storage",
			desc: "Private keys are the only way to access your crypto holdings; therefore, storing them securely is vital. Using hardware wallets or cold storage options minimizes exposure to online threats. Protecting your private keys ensures sole control over your assets and reduces the risk of theft.",
			logo: <RiShieldKeyholeFill />,
			id: 3,
		},
	];

	const communityData = [
		{ icon: <FaInstagramSquare />, id: 1 },
		{ icon: <IoLogoFacebook />, id: 2 },
		{ icon: <FaWhatsappSquare />, id: 3 },
		{ icon: <FaTelegram />, id: 4 },
		{ icon: <FaSquareXTwitter />, id: 5 },
		{ icon: <IoLogoYoutube />, id: 6 },
		{ icon: <AiFillTikTok />, id: 7 },
		{ icon: <FaLine />, id: 8 },
		{ icon: <SiCoinmarketcap />, id: 9 },
	];

	const content = (
		<section className="w-full  lg:w-[85%]  lg:mx-auto    flex  flex-col bg-white rounded-t-xl   rounded-b-xl lg:justify-center  lg:items-center    text-black        my-[1rem]  ">
			<div className="flex flex-col justify-center gap-[2rem]  bg-white  rounded-t-xl  p-[1rem]">
				<h4 className="min-w-fit     text-black  my-[1rem]   mx-auto  text-center font-bold  text-[1.4rem]  ">
					Robust Tools for Industry Leaders
				</h4>
				<p className="w-fit lg:w-[70%] mx-auto  text-gray-500 text-center font-medium  text-[0.9rem]  ">
					Gain access to sophisticated investment tools that deliver real-time
					market analysis and strategic insights, enabling you to maintain a
					competitive edge.
				</p>
				<ul className="flex   flex-col  lg:flex-row justify-center  my-[1rem]  items-center  gap-[1rem]">
					{assetData.map((data) => (
						<li
							key={data.id}
							className="w-[90%]  mx-auto p-[1rem]  bg-white  border-2  border-gray-400     rounded-[1.5rem]  text-left  flex   flex-col  justify-start  items-start  gap-[1rem]">
							<div className="text-[3rem]  text-blue-200">{data.logo}</div>
							<h5 className="font-bold  text-black capitalize  text-[1.1rem] ">
								{data.title}
							</h5>
							<p className="text-gray-400 text-[0.9rem]  ">{data.desc}</p>
						</li>
					))}
				</ul>
			</div>

			<div className=" w-full    bg-black text-white    rounded-t-2xl  rounded-b-2xl  ">
				<div className="my-[3rem]  flex  flex-col justify-center  items-center  gap-[1rem]  ">
					<h4 className="min-w-fit mx-auto    text-center font-bold  my-[1rem]  text-[1.4rem]  ">
						Trade effortlessly from your comfort zone
					</h4>
					<img
						src={mainMock}
						alt="iphonemocker"
						className="w-[80%]  lg:w-[30%]    h-full  mx-auto"
					/>

					<hr className=" w-[5rem] mt-[1rem]  bg-white  p-[0.01rem]" />

					<p className="w-[85%]  pl-[1.2rem] my-[1rem] ">
						We believe that trading should be seamless and accessible for
						everyone. With our advanced platform, you can trade effortlessly
						from your comfort zone whether at home, on the go, or anywhere in
						the world. Enjoy real-time analytics, secure transactions, and user
						friendly tools designed to empower both beginners and experienced
						traders to achieve their financial goals with ease.
					</p>
				</div>
				<Box>
					<Link
						to="/en/register"
						className=" text-white  capitalize flex justify-center my-[3rem] items-center gap-[0.5rem] min w-[95%]  md:w-[60%]  px-[1.2rem]  py-[0.5rem] mx-auto bg-gradient-to-r from-red-500 to-blue-500   rounded-full  text-[0.9rem]  text-center  font-bold  tracking-wide   ">
						Sign Up Now & to start trading
					</Link>
				</Box>
				{/* <div>
					<h4 className="min-w-fit mx-auto  text-center font-bold  my-[1rem]  text-[1.4rem]  ">
						community
					</h4>

					<ul className=" mx-auto   flex  justify-center  items-center  gap-[0.7rem]">
						{communityData.map((data) => (
							<li key={data.id} className="text-[1.2rem]  text-white">
								{data.icon}
							</li>
						))}
					</ul>
				</div> */}
			</div>

			<div className="flex flex-col justify-center gap-[2rem]  bg-white  rounded-t-xl  rounded-b-xl p-[1rem]">
				<h4 className="min-w-fit     text-black  my-[1rem]   mx-auto  text-center font-bold  text-[1.4rem]  ">
					An Investment Platform Designed with Your Security in Mind
				</h4>
				<img
					src={cryptosec}
					alt="cryptosec"
					className="w-[80%] lg:w-[40%] mx-auto rounded-xl"
				/>
				<p className="w-fit lg:w-[70%] mx-auto  text-gray-500 text-center font-medium  text-[0.9rem]  ">
					Prioritizing your security is fundamental to our operations. We employ
					comprehensive security measures, including multi-layer encryption,
					two-factor authentication, and continuous system monitoring, to ensure
					the protection of your data and assets. Our state-of-the-art security
					protocols establish a secure and risk-mitigated environment, enabling
					you to focus confidently on your investment strategies.
				</p>
				<ul className="flex   flex-col  lg:flex-row justify-center  my-[1rem]  items-center  gap-[1rem]">
					{cryptoSecData.map((data) => (
						<li
							key={data.id}
							className="w-[90%]  mx-auto p-[1rem]  bg-white  border-2  border-gray-300     rounded-[1.5rem]  text-left  flex   flex-col  justify-start  items-start  gap-[1rem]">
							{/* <div className="text-[3rem]  text-blue-200">{data.logo}</div> */}
							<h5 className="font-bold  text-black capitalize  text-[1.1rem] ">
								{data.title}
							</h5>
							<hr />
							<p className="text-gray-400 text-[0.9rem]  ">{data.desc}</p>
						</li>
					))}
				</ul>
			</div>

			{/* <Votingcarousel /> */}
		</section>
	);

	return content;
}
